/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});
	// Prevent Dropdown buttons in Main Nav from doing anything when clicked
	const dropdownLinks = document.querySelectorAll('.menu-item a[href="#"]');
	for (dropdownLink in dropdownLinks) {
		dropdownLinks[dropdownLink].addEventListener('click', (event) => {
			event.preventDefault();
		})
	}


}); 

document.addEventListener('DOMContentLoaded', function() {
	// Check if the current URL contains '/sitemap'
	if (window.location.href.indexOf('/sitemap') > -1) {
	  // Add the 'sitemap-page' class to the body tag
	  document.body.classList.add('sitemap-page');
	  
	  // Find the div with class 'site-content'
	  const siteContentDiv = document.querySelector('.site-content');
	  
	  // Create a new h1 element
	  const h1Element = document.createElement('h1');
	  
	  // Set the text content of the h1
	  h1Element.textContent = 'Sitemap';
	  
	  // Prepend the h1 to the site-content div (if it exists)
	  if (siteContentDiv) {
		siteContentDiv.insertBefore(h1Element, siteContentDiv.firstChild);
	  }
	}
});